export const SET_JUDGING_DATA = "SET_JUDGING_DATA";
